import { IPendingSocialAction } from "./pendingSocialAction";

/**
 * Whether the full-screen "Getting your booking ready" cover belongs over a
 * social provider's hand-back.
 *
 * Only a sign-in begun inside the booking flow earns it. That one ends in a
 * redirect — to the checkout for Book Now, back to the product for Add to Cart —
 * so without a cover it reads as three unrelated pages flashing past: the
 * callback lands on /login, the route guard bounces the now signed-in visitor to
 * the home page, and only then does the handler send them on.
 *
 * An ordinary sign-in from the login page has nowhere to go afterwards, so
 * nothing ever navigates away from the cover and it sat over the page saying
 * "Getting your booking ready" for good.
 *
 * The parked action is the marker for the booking flow: only the Book Now and
 * Add to Cart panels record one before handing off to the provider.
 */
export const shouldCoverSocialHandback = (
    hasProviderToken: boolean,
    pending: IPendingSocialAction | null,
): boolean => hasProviderToken && pending !== null;
